import Header from '../header'
import Table from '../table/Table'
import AuthorCell from './cells/AuthorCell'
import LastEditedCell from './cells/LastEditedCell'
import PublishDateCell from './cells/PublishDateCell'
import StatusCell from './cells/StatusCell'
import TitleCell from './cells/TitleCell'
import EmptyPage from '../empty-page/EmptyPage'
import Pagination from '../pagination/Pagination'
import Loader from '../ui-components/Loader'
import ArticlesOverviewFilters from './ArticlesOverviewFilters'

const model = [{
  header: 'Title', accessor: 'title', cell: TitleCell()
}, {
  header: 'Status', accessor: 'status', cell: StatusCell()
}, {
  header: 'Author', accessor: 'author', cell: AuthorCell()
}, {
  header: 'Category', accessor: 'category'
}, {
  header: 'Publish date', accessor: 'publish_date', cell: PublishDateCell(), sorting: 'publishedAt'
}, {
  header: 'Last edited', accessor: 'last_edited_date', cell: LastEditedCell(), sorting: 'lastEditedAt'
}]

const PaginationComponent = ({ pagination, onPageChange, onPageSizeChange, displayListUpwards }) => (
  <Pagination
    displayListUpwards={displayListUpwards}
    currentPage={pagination.page}
    total={pagination.total}
    pageSize={pagination.pageSize}
    pageSizes={[10, 25, 50]}
    onPageChange={(page) => onPageChange(page)}
    onPageSizeChange={(pageSize) => onPageSizeChange(pageSize)}
  />
)

const ArticlesOverviewPresenter = ({
  articles,
  publicLabels,
  categories,
  authors,
  filters,
  defaultCdn,
  loading,
  onApplyFilters,
  onFilterChange,
  paginationOptions,
  areFiltersApplied,
  onClearFilterCriteria,
  sort,
  onSortChange
}) => (
  <div class='article-overview'>
    <Header title='Articles' disableCancelButton disableSaveButton />
    { (articles.length > 0 || areFiltersApplied) && <ArticlesOverviewFilters
      categories={categories}
      publicLabels={publicLabels}
      authors={authors}
      filters={filters}
      onFilterChange={onFilterChange}
      onApplyFilters={onApplyFilters}
      onClearFilterCriteria={onClearFilterCriteria}
    /> }
    {loading && <Loader />}
    {articles.length > 0
      ? <div>
        <div className='article-overview__table-info'>
          <span className='article-overview__counter'>{paginationOptions.pagination.total} Articles</span>
          <PaginationComponent {...paginationOptions} />
        </div>
        <Table model={model} rows={articles} rowId={'article_id'} sort={sort} onSortChange={onSortChange} />
        <PaginationComponent {...paginationOptions} displayListUpwards />
      </div>
      : !loading && areFiltersApplied
        ? <div>
          <EmptyPage
            img_src={`${defaultCdn}/images/empty_result.png`}
            header='No results found'
            text={'Sorry, that filter combination has no results.\n Please try different criteria.'}
          />
        </div> : !loading
          ? <EmptyPage
            img_src={`${defaultCdn}/images/empty_page.png`}
            header='There are no articles yet'
            text={'Seems like no one on your team has created an article. \n Start now by creating a new article.'}
            button={{ link: '/content/new/article', text: 'New article' }}
          /> : null
    }
  </div>
)

export default ArticlesOverviewPresenter
